import {
  FETCH_ACCOUNT_ACTIVITY,
  FETCH_ACCOUNT_ACTIVITY_SUCCESS,
  FETCH_ACCOUNT_ACTIVITY_FAILURE,
  RESET_DATA_FOR_ACCOUNT_ACTIVITY_PAGE,
} from './types';
import {
  fetchAccountActivity as fetchAccountActivityApi,
} from '../../api';

export const fetchAccountActivity = ({
  period,
  companyCode,
  taxYear,
  countryTaxType,
  entryType,
  entryActivity,
  account,
  bookType,
}) => async dispatch => {
  try {
    dispatch({
      type: FETCH_ACCOUNT_ACTIVITY,
    });

    const response = await fetchAccountActivityApi({
      periodName: period.name,
      companyCode,
      taxYear,
      countryTaxType,
      slAccount: `${entryType}_${entryActivity}`,
      accountId: account || 'x',
      bookType,
    });

    return dispatch({
      type: FETCH_ACCOUNT_ACTIVITY_SUCCESS,
      accountActivity: response,
    });
  } catch (error) {
    return dispatch({
      type: FETCH_ACCOUNT_ACTIVITY_FAILURE,
    });
  }
};

export const resetDataForAccountActivityPage = () => ({
  type: RESET_DATA_FOR_ACCOUNT_ACTIVITY_PAGE,
});
